import React, { useEffect } from 'react';
import {
  IconButton,
  Box,
  CloseButton,
  Flex,
 
  useColorModeValue,
  Link,
  Drawer,
  DrawerContent,
  Text,
  useDisclosure,
  Button,
  MenuButton,
  Menu,
  MenuList,
  MenuItem,
  useMediaQuery,
} from '@chakra-ui/react';
import {
    FiMenu
} from 'react-icons/fi'
import { useNavigate } from 'react-router-dom';
import useAuth from '../context/AuthContext';
import useApp from '../context/AppContext';

export default function Sidebar({children}) {
    
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [width] = useMediaQuery('(max-width: 768px)')
  
    // useEffect(() => {
    //   console.log("width", width)
      
    // }, [width])

    return (
        <Box >
          <SidebarContent
            onClose={() => onClose}
            isOpen={isOpen}
            display={{ base: 'none', md: 'block' }}
          />
          <Drawer
            autoFocus={false}
            isOpen={isOpen}
            placement="left"
            onClose={onClose}
            returnFocusOnClose={false}
            onOverlayClick={onClose}
            size="full"
          >
            <DrawerContent>
              <SidebarContent onClose={onClose} />
            </DrawerContent>
          </Drawer>
          {/* mobilenav */}
          {width?
          <MobileNav onOpen={onOpen} onClose={onClose}/>
          :""}
            
          <Box ml={{ base: 0, md: 60 }}>
            {children}
          </Box>
        </Box>
    );
}


const SidebarContent = ({ onClose,isOpen, ...rest }) => {

    const Navigate = useNavigate()
    const goToCat = (cat) => Navigate({
        pathname: "/players",
        search: `?cat=${cat}`
    })

    // console.log("Open", isOpen)

    const goToTeam = (id) => Navigate({
        pathname: "/team",
        search: `?team=${id}`
    })

    const {user, signIn, logout} = useAuth()
    const {catogories, teams} = useApp()


    return (
      <Box
        transition="3s ease"
        borderRight="1px"
        borderRightColor={useColorModeValue('gray.200', 'gray.700')}
        w={{ base: 'full', md: 60 }}
        pos="fixed"
        h="full"
        overflowY={'scroll'}
        overflowX={'hidden'}

        pb={5}

        css={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            width: "6px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#8ccef0",
            borderRadius: "24px",
          },
        }}

        {...rest}>
        <Flex h="20" alignItems="center" mx="8" justifyContent="space-between">
          <Text fontSize="2xl" fontFamily="monospace" fontWeight="bold">
            Auction Point
          </Text>
          <CloseButton display={{ base: 'flex', md: isOpen === undefined?'flex':"none" }} onClick={onClose} />
        </Flex>

        <Flex
            direction={'column'}
            px={4}
            gap={4}
        >

            {/* <Button onClick={() => NavLink(onClose, () => Navigate('/'))}>
                Home
            </Button> */}
            <Button onClick={() => NavLink(onClose, () => Navigate('/'))}>
                Home
            </Button>

            {user?
                <>
                    <Button onClick={() => NavLink(onClose, () => Navigate('/addplayer'))}>Add Player</Button>
                    <Button onClick={() => NavLink(onClose, () => Navigate('/addcat'))}>Add Category</Button>
                    <Button onClick={() => NavLink(onClose, () => Navigate('/addteam'))}>Add Team</Button>
                    <Button onClick={() => NavLink(onClose, () => Navigate('/allplayers'))}>All Players</Button> 
                    <Button onClick={() => NavLink(onClose, () => Navigate('/soldplayers'))}>Sold Players</Button>
                    <Button onClick={() => NavLink(onClose, () => Navigate('/reservedplayers'))}>Reserved Players</Button>
                </>:""
            }

            <Menu>
                    
                <MenuButton 
                    as={Button} 
                    >Categories</MenuButton>
                
                <MenuList>
                    {catogories.map(c => (
                        <MenuItem key={c} onClick={() => NavLink(onClose,() => goToCat(c))}>{c}</MenuItem>
                        ))}
                </MenuList>
                
            </Menu>
            <Button onClick={() => NavLink(onClose, () => Navigate('/teams'))}>Teams Point Table</Button>
            <Menu>
                
                <MenuButton 
                    as={Button} 
                    // rightIcon={<FaArrowRight/>}
                    >Teams</MenuButton>
                
                <MenuList
                    
                >
                    <Box
                        overflowY={'scroll'}
                        maxH={"200px"}

                        css={{
                            "&::-webkit-scrollbar": {
                              width: "4px",
                            },
                            "&::-webkit-scrollbar-track": {
                              width: "6px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: "#8ccef0",
                              borderRadius: "24px",
                            },
                          }}
                    >

                    {teams.list.map((t, i) => (
                        <MenuItem key={t} onClick={() =>  NavLink(onClose,() => goToTeam(t))}>{i+1}. {teams.teams[t].name}</MenuItem>
                        ))}
                    </Box>
                </MenuList>
               
            </Menu>
            
            {user?
            <Button onClick={logout}>SignOut</Button>
            :<Button onClick={signIn}>SignIn</Button>
            }

        </Flex>
      </Box>
    );
};


const NavLink = (onClose, func) => {
    func()
    onClose()
}

const MobileNav = ({ onOpen,onClose, ...rest }) => {
    return (
      <Flex
      ml={{ base: 0, md: 60 }}
      px={{ base: 4, md: 4 }}
      height="20"
      alignItems="center"
      borderBottomWidth="1px"
      borderBottomColor={useColorModeValue('gray.200', 'gray.700')}
      justifyContent={{ base: 'space-between', md: 'space-between' }}
      {...rest}
      >
        <IconButton
          variant="outline"
          onClick={onOpen}
          aria-label="open menu"
          icon={<FiMenu />}
        />
  
        <Text fontSize="2xl" ml="8" fontFamily="monospace" fontWeight="bold">
          Auction Point
        </Text>
      </Flex>
    );
  };